import {Component, Inject, OnInit} from '@angular/core';
import {SendMessageDialogComponent} from '../send-message-dialog/send-message-dialog.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-send-cv-dialog',
  templateUrl: './send-cv-dialog.component.html',
  styleUrls: ['./send-cv-dialog.component.scss']
})
export class SendCvDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SendMessageDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
